import { DefaultOptions, QueryClient } from '@tanstack/react-query';

export const queryConfig = { queries: { refetchOnWindowFocus: false } } satisfies DefaultOptions;

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});
